import { render, staticRenderFns } from "./InvoiceDetailFromNetsisView.vue?vue&type=template&id=220a2e64"
import script from "./InvoiceDetailFromNetsisView.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailFromNetsisView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports